import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { SearchAcctsComponent } from '../search-accts/search-accts.component';
import { JournalEntryComponent } from '../journal-entry/journal-entry.component';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-journal-entry-list',
  templateUrl: './journal-entry-list.component.html',
  styleUrls: ['./journal-entry-list.component.css']
})
export class JournalEntryListComponent implements OnInit {

  public menu_item_id = '10';
  public add_auth;
  public edit_auth;
  public del_auth;

  // search_obj = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [
  //     {
  //       'table_name': '`customer`', 'selected_no': 'customer_no',
  //       'field_list': ['customer_no', 'customer_name', 'customer_name_en']
  //     },
  //     {
  //       'table_name': '`supplier`', 'selected_no': 'supplier_no',
  //       'field_list': ['supplier_no', 'supplier_name', 'supplier_name_en']
  //     },
  //     {
  //       'table_name': '`bank_account`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'bank_acct_number', 'account_name', 'account_name_en']
  //     },
  //     {
  //       'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en']
  //     }
  //   ]
  // };

  search_obj = {
    'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
    'table_list': [
      {
        'table_name': '`sub_acct`', 'selected_no': 'acct_number',
        'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
        'condition': " AND `sub_acct`.`is_leaf` = '1' AND `sub_acct`.`is_cc` = '1'"
      }
    ]
  };

  private dp = [];
  displayedColumns = ['entry_no', 'entry_date', 'entry_desc', 'acct_name', 'debit_amount', 
    'credit_amount', 'branch_name', 'print', 'edit', 'del'];  //, 'comment', 'view' 

  displayedColumns2 = ['entry_no', 'entry_date', 'entry_desc', 'acct_name', 'debit_amount', 
    'credit_amount', 'branch_name'];

  dataSource = new MatTableDataSource(this.dp);
  acctDialogRef: MatDialogRef<SearchAcctsComponent>;
  journalDialogRef: MatDialogRef<JournalEntryComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  acct_number = '';
  // acct_name = '';
  from_date = '';
  to_date = '';

  // from_acct = {sub_acct_name: '', sub_acct_name_en: '', sub_acct_id: '0', acct_number: '', mobile: ''};
  // to_acct = {sub_acct_name: '', sub_acct_name_en: '', sub_acct_id: '0', acct_number: '', mobile: ''};
  public dialog_data = {};

  model = {
    'table_name': 'journal_entry', 'from_date': new Date(), 'to_date': new Date(), 'entry_no': '',
    'branch_id': '0', 'title': 'قائمة القيود'
  };

  branchList = [];

  Success_Msg; Error_Msg; Del_Msg; Acct_Placeholder; Journal_Entry_List;
  From_Date; To_Date; Entry_No; Acct; Search_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private router: Router, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Acct_Placeholder;

    translate.get('Journal_Entry_List').subscribe((res: string) => {
      this.Journal_Entry_List = res;
    });
    this.model['title'] = this.Journal_Entry_List;

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Entry_No').subscribe((res: string) => {
      this.Entry_No = res;
    });

    translate.get('Acct').subscribe((res: string) => {
      this.Acct = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);


    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  print(entry_no = null) {

    if (entry_no == null) {
      let html_data = '';
      let form = (document.getElementById('form1') as HTMLFormElement);

      html_data = '<table cellpadding="8" cellspacing="0"><tr>';
      html_data += '<td width="33%"> ' + this.Entry_No + ': ' + this.model['entry_no'] + '</td>';
      html_data += '<td width="33%"> ' + this.From_Date + ': ' + this.from_date + '</td>';
      html_data += '<td width="33%"> ' + this.To_Date + ': ' + this.to_date + '</td></tr>';
      html_data += '<tr><td colspan="3"> ' + this.Acct + ': ' +
        (this.acct_number != '' ? (document.getElementById('search_value_0') as HTMLInputElement).value : '') +
        ' </td></tr></table>';

      let table = (document.getElementById('journal_table2') as HTMLTableElement);
      html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
    }
    else
      window.open(this.applicationConstants.generatePDF + "?entry_no=" + entry_no, "_blank");
    //  {
    //   form.action = this.applicationConstants.generatePDF + "?entry_no=" + entry_no;
    //   form.submit();
    // }
  }

  onChangeSearch = function (search_result: object) {
    // console.log(search_result);
    this.acct_number = search_result['no'];
  }

  view() {
    this.dp = [];

    if ((this.model['from_date'] == undefined || this.model['to_date'] == undefined) &&
      this.model['entry_no'] == '') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getJournalList' }; 
    
    if (this.model['entry_no'] != '') {
      obj['entry_no'] = this.model['entry_no'];

      if (this.branchList.length == 2) 
        obj['branch_id'] = this.branchList[1]['branch_id'];
      else {
        let branch_list = [];
        this.branchList.forEach(element => {
          if (element.branch_id != '0')
            branch_list.push({ 'branch_id': element.branch_id });
        });
        obj['branch_list'] = branch_list;
      }
    }
    else {
      if (this.model['from_date'] != undefined) {
        this.from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
          this.model['from_date'].getDate() + " 00:00:00";
  
          obj['from_date'] = this.from_date;
      }

      if (this.model['to_date'] != undefined) {
        this.to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
          this.model['to_date'].getDate() + " 23:59:59";
  
        obj['to_date'] = this.to_date;
      }

      if (this.acct_number != '')
        obj['acct_number'] = this.acct_number;
      else
        (document.getElementById('search_value_0') as HTMLInputElement).value = '';

      if (this.model['branch_id'] == '0') {
        if (this.branchList.length == 2) 
          obj['branch_id'] = this.branchList[1]['branch_id'];
        else {
          let branch_list = [];
          this.branchList.forEach(element => {
            if (element.branch_id != '0')
              branch_list.push({ 'branch_id': element.branch_id });
          });
          obj['branch_list'] = branch_list;
        }
      }
      else 
        obj['branch_id'] = this.model['branch_id'];
    }

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

    // let cond = '';
    // if (this.model['from_date'] != undefined) {
    //   this.from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
    //     this.model['from_date'].getDate() + " 00:00:00";

    //   cond += " AND `journal_entry`.`entry_date` >= '" + this.from_date + "'";
    // }

    // if (this.model['to_date'] != undefined) {
    //   this.to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
    //     this.model['to_date'].getDate() + " 23:59:59";

    //   cond += " AND `journal_entry`.`entry_date` <= '" + this.to_date + "'";
    // }

    // if (this.model['entry_no'] != undefined && this.model['entry_no'] != '')
    //   cond = " AND `journal_entry`.`entry_no` LIKE '%" + this.model['entry_no'] + "%'";

    // if (this.acct_number != '')
    //   cond += " AND `journal_entry`.`acct_number` = '" + this.acct_number + "'";
    // else
    //   (document.getElementById('search_value_0') as HTMLInputElement).value = '';

    // if (this.model['branch_id'] != '0')
    //   cond += " AND `journal_entry`.`branch_id` = '" + this.model['branch_id'] + "'";

    // else if (this.model['branch_id'] == '0') {
    //   let index = 1;
    //   let list_length = this.branchList.length;

    //   cond += " AND `journal_entry`.`branch_id` IN (";
    //   this.branchList.forEach(element => {
    //     if (element.branch_id != '0') {
    //       if (index < list_length)
    //         cond += " '" + element.branch_id + "',";
    //       else if (index == list_length)
    //         cond += " '" + element.branch_id + "'";
    //     }
    //     index++;
    //   });
    //   cond += ")";
    // }

    // let query = "SELECT `journal_entry`.* FROM `journal_entry` WHERE `journal_entry`.`status` != '0'" + cond;
    // let obj = { cmd: 'getList', query: query };
    // console.log(query);

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.dp = data.data['list'];
    //     this.dp.forEach(element => {
    //       element.entry_date = (element.entry_date).substring(0, 10);
    //     });
    //     this.dataSource = new MatTableDataSource(this.dp);
    //     this.dataSource.sort = this.sort;

      // });
  }

  delJorEntry(entry_no) {
    console.log(entry_no);
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'entry_no': entry_no }];
      let obj = { cmd: 'deleteRec', values: values };
      console.log(values);
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.view();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
